import { Box, Divider, Flex, Heading } from '@chakra-ui/react';
import { ElementsRenderer } from '../../shared';

const ReadingComprehensionElement = ({ questionRef }) => {
  const { elements } = questionRef;

  return (
    <Box>
      <Heading color={'#686868'} size={'md'}>
        Reading Comprehension
      </Heading>
      <Flex w="95%" flexDir={'column'}>
        <Box
          fontSize="lg"
          id="q-text"
          whiteSpace="normal"
          wordBreak="break-word"
          overflowX="hidden"
          minH="30px"
          mt={2}
          mb={1}
          h="auto"
          sx={{
            pre: {
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              maxWidth: '100%',
              backgroundColor: 'transparent',
              border: 'none',
              padding: 0
            }
          }}
        >
          <ElementsRenderer elements={elements} />
        </Box>
      </Flex>
      <Divider my={2} />
    </Box>
  );
};

export default ReadingComprehensionElement;
